import '@modifi/plugin-authentication/register'
import '@modifi/plugin-authorization/register'
import '@modifi/plugin-countries/register'
import '@modifi/plugin-dialogs/register'
import {init as i18nInit} from '@modifi/plugin-i18n/register'
import '@modifi/plugin-user/register'
import '@modifi/plugin-admin-onboarding/register'
import '@modifi/onboarding-admin-layout/register'
import '@modifi/plugin-banners/register'

export const initPlugins = (options: Record<string, any> = {}): Promise<any[]> =>
  Promise.all([i18nInit(options?.i18n)])
